import React, {useContext} from 'react'

import {
    theme as defaultTheme, styled,
} from 'stitches/config'

import {
    NinchatChevronUpDownIcon,
} from 'components/Icon'
import {ThemeContext} from 'stitches/ThemeProvider/ThemeProvider'

import {selectWrapper} from './styles'


import {
    styledSelect,
} from 'components/Form/styles/FormView'

const StyledSelectWrapper = styled('div', selectWrapper)
const StyledSelect = styled('select', styledSelect)

export const SelectView = (props: any) => {
    const {
        children, css, cssSelect, register, ...other
    } = props

    const theme = useContext(ThemeContext) as typeof defaultTheme

    return (
        <StyledSelectWrapper css={css}>
            <StyledSelect css={cssSelect} {...register} {...other}>
                {children}
            </StyledSelect>
            <NinchatChevronUpDownIcon color={theme.colors?.inputIconColor?.value} size={25} />
        </StyledSelectWrapper>
    )
}

SelectView.defaultProps = {
    children: null,
    css: {},
    cssSelect: {},
}

